var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.modalShow
      ? _c("div", { staticClass: "h-vertical-align-container" }, [
          _c("div", {
            staticClass: "modal__close",
            on: {
              click: function($event) {
                _vm.overlay()
              }
            }
          }),
          _c("div", {
            staticClass: "modal__overlay",
            on: {
              click: function($event) {
                _vm.overlay()
              }
            }
          }),
          _c("div", { staticClass: "videoModal__wrapper" }, [
            _c(
              "div",
              {
                staticClass: "fluid__video",
                attrs: { id: "fluid__video--tutorial" },
                domProps: { innerHTML: _vm._s(_vm.ytVideo) }
              },
              [_vm._v(_vm._s(_vm.ytVideo))]
            )
          ])
        ])
      : _vm._e(),
    _vm._m(0),
    _c(
      "section",
      {
        directives: [
          {
            name: "scroll",
            rawName: "v-scroll",
            value: _vm.handleScroll,
            expression: "handleScroll"
          }
        ]
      },
      [
        _c("div", { staticClass: "caseStudies__content" }, [
          _c("aside", { staticClass: "caseStudies__content--menu" }, [
            _c(
              "ul",
              { ref: "caseStudiesMenu", attrs: { id: "caseStudies--menu" } },
              [
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.scrollTo("#topbrands")
                      }
                    }
                  },
                  [_vm._v("Top Brands")]
                ),
                _c("div", { staticClass: "companies" }),
                _c("li", { staticClass: "menu--active" }, [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.scrollTo("#pepsi")
                        }
                      }
                    },
                    [_vm._v("PepsiCo")]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.scrollTo("#microsoft")
                        }
                      }
                    },
                    [_vm._v("Microsoft")]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.scrollTo("#mercedes")
                        }
                      }
                    },
                    [_vm._v("Mercedes-Benz")]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.scrollTo("#bpaa")
                        }
                      }
                    },
                    [_vm._v("BPAA")]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.scrollTo("#alberta")
                        }
                      }
                    },
                    [_vm._v("Travel Alberta")]
                  )
                ]),
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.scrollTo("#startups")
                      }
                    }
                  },
                  [_vm._v("Startups")]
                ),
                _c("li", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.scrollTo("#theride")
                        }
                      }
                    },
                    [_vm._v("The Ride")]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.scrollTo("#giftagram")
                        }
                      }
                    },
                    [_vm._v("Giftagram")]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.scrollTo("#inkbox")
                        }
                      }
                    },
                    [_vm._v("Inkbox")]
                  )
                ]),
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.scrollTo("#smbs")
                      }
                    }
                  },
                  [_vm._v("SMBs")]
                ),
                _c("li", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.scrollTo("#collage")
                        }
                      }
                    },
                    [_vm._v("Collage")]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.scrollTo("#queenlaundry")
                        }
                      }
                    },
                    [_vm._v("Queen Street Laundry")]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.scrollTo("#plentea")
                        }
                      }
                    },
                    [_vm._v("Plentea")]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.scrollTo("#fitfactory")
                        }
                      }
                    },
                    [_vm._v("Fit Factory Fitness")]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.scrollTo("#blackwidow")
                        }
                      }
                    },
                    [_vm._v("Black Widow Tattoo")]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.scrollTo("#buggigattolo")
                        }
                      }
                    },
                    [_vm._v("Buggigattolo")]
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.scrollTo("#anti")
                        }
                      }
                    },
                    [_vm._v("ANTI")]
                  )
                ])
              ]
            )
          ]),
          _c("div", { staticClass: "caseStudies__content--videos" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.videoOptions,
                    expression: "videoOptions"
                  }
                ],
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.videoOptions = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    function($event) {
                      _vm.scrollTo(_vm.videoOptions)
                    }
                  ]
                }
              },
              [
                _c(
                  "option",
                  {
                    attrs: {
                      value: "",
                      selected: "selected",
                      disabled: "disabled"
                    }
                  },
                  [_vm._v("Jump to Category")]
                ),
                _c("option", { attrs: { value: "#pepsi" } }, [
                  _vm._v("Pepsico")
                ]),
                _c("option", { attrs: { value: "#microsoft" } }, [
                  _vm._v("Microsoft")
                ]),
                _c("option", { attrs: { value: "#mercedes" } }, [
                  _vm._v("Mercedes-Benz")
                ]),
                _c("option", { attrs: { value: "#bpaa" } }, [_vm._v("BPAA")]),
                _c("option", { attrs: { value: "#alberta" } }, [
                  _vm._v("Travel Alberta")
                ]),
                _c("option", { attrs: { value: "#theride" } }, [
                  _vm._v("The Ride")
                ]),
                _c("option", { attrs: { value: "#giftagram" } }, [
                  _vm._v("Giftagram")
                ]),
                _c("option", { attrs: { value: "#inkbox" } }, [
                  _vm._v("Inkbox")
                ]),
                _c("option", { attrs: { value: "#collage" } }, [
                  _vm._v("Collage")
                ]),
                _c("option", { attrs: { value: "#queenlaundry" } }, [
                  _vm._v("Queen Street Laundry")
                ]),
                _c("option", { attrs: { value: "#plentea" } }, [
                  _vm._v("Plentea")
                ]),
                _c("option", { attrs: { value: "#fitfactory" } }, [
                  _vm._v("Fit Factory Fitness")
                ]),
                _c("option", { attrs: { value: "#blackwidow" } }, [
                  _vm._v("Black Widow Tattoo")
                ]),
                _c("option", { attrs: { value: "#buggigattolo" } }, [
                  _vm._v("Buggigattolo")
                ]),
                _c("option", { attrs: { value: "#anti" } }, [_vm._v("ANTI")])
              ]
            ),
            _c(
              "section",
              {
                ref: "topbrands",
                staticClass: "noBoxShadow",
                attrs: { id: "topbrands" }
              },
              [_vm._m(1)]
            ),
            _c("section", { staticClass: "noBoxShadow" }, [
              _c(
                "div",
                {
                  ref: "microsoft",
                  staticClass: "caseStudies__item",
                  attrs: { id: "microsoft" }
                },
                [_vm._m(2), _vm._m(3), _vm._m(4)]
              )
            ]),
            _c("section", { staticClass: "noBoxShadow" }, [
              _c(
                "div",
                {
                  ref: "mercedes",
                  staticClass: "caseStudies__item",
                  attrs: { id: "mercedes" }
                },
                [_vm._m(5), _vm._m(6), _vm._m(7)]
              )
            ]),
            _c("section", { staticClass: "noBoxShadow" }, [
              _c(
                "div",
                {
                  ref: "bpaa",
                  staticClass: "caseStudies__item",
                  attrs: { id: "bpaa" }
                },
                [
                  _vm._m(8),
                  _c("div", { staticClass: "caseStudies__item--content" }, [
                    _vm._m(9),
                    _c("div", { staticClass: "caseStudies--cinemagraph" }, [
                      _c("div", { staticClass: "video__container" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://www.youtube.com/watch?v=y2U-d6k4apU"
                            },
                            on: {
                              click: function($event) {
                                _vm.ytModal($event)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "lazy",
                              attrs: {
                                "data-src":
                                  "https://i1.ytimg.com/vi/y2U-d6k4apU/maxresdefault.jpg"
                              }
                            }),
                            _c("div", { staticClass: "playbtn" })
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._m(10)
                ]
              )
            ]),
            _c("section", { staticClass: "noBoxShadow" }, [
              _c(
                "div",
                {
                  ref: "alberta",
                  staticClass: "caseStudies__item",
                  attrs: { id: "alberta" }
                },
                [
                  _vm._m(11),
                  _c("div", { staticClass: "caseStudies__item--content" }, [
                    _vm._m(12),
                    _c("div", { staticClass: "caseStudies--cinemagraph" }, [
                      _c("div", { staticClass: "video__container" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://www.youtube.com/watch?v=Va1Edc5AgEk"
                            },
                            on: {
                              click: function($event) {
                                _vm.ytModal($event)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "lazy",
                              attrs: {
                                "data-src":
                                  "https://i1.ytimg.com/vi/Va1Edc5AgEk/maxresdefault.jpg"
                              }
                            }),
                            _c("div", { staticClass: "playbtn" })
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._m(13)
                ]
              )
            ]),
            _c(
              "section",
              {
                ref: "startups",
                staticClass: "noBoxShadow",
                attrs: { id: "startups" }
              },
              [
                _c(
                  "div",
                  {
                    ref: "theride",
                    staticClass: "caseStudies__item",
                    attrs: { id: "theride" }
                  },
                  [
                    _vm._m(14),
                    _c("div", { staticClass: "caseStudies__item--content" }, [
                      _vm._m(15),
                      _c("div", { staticClass: "caseStudies--cinemagraph" }, [
                        _c("div", { staticClass: "video__container" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "https://www.youtube.com/watch?v=m3cgG6qhcnI"
                              },
                              on: {
                                click: function($event) {
                                  _vm.ytModal($event)
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "lazy",
                                attrs: {
                                  "data-src":
                                    "https://i1.ytimg.com/vi/m3cgG6qhcnI/maxresdefault.jpg"
                                }
                              }),
                              _c("div", { staticClass: "playbtn" })
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._m(16)
                  ]
                )
              ]
            ),
            _c("section", { staticClass: "noBoxShadow" }, [
              _c(
                "div",
                {
                  ref: "giftagram",
                  staticClass: "caseStudies__item",
                  attrs: { id: "giftagram" }
                },
                [
                  _vm._m(17),
                  _c("div", { staticClass: "caseStudies__item--content" }, [
                    _vm._m(18),
                    _c("div", { staticClass: "caseStudies--cinemagraph" }, [
                      _c("div", { staticClass: "video__container" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://www.youtube.com/watch?v=Zo5kYXU9DxM"
                            },
                            on: {
                              click: function($event) {
                                _vm.ytModal($event)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "lazy",
                              attrs: {
                                "data-src":
                                  "https://i1.ytimg.com/vi/Zo5kYXU9DxM/maxresdefault.jpg"
                              }
                            }),
                            _c("div", { staticClass: "playbtn" })
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._m(19)
                ]
              )
            ]),
            _c("section", { staticClass: "noBoxShadow" }, [
              _c(
                "div",
                {
                  ref: "inkbox",
                  staticClass: "caseStudies__item",
                  attrs: { id: "inkbox" }
                },
                [
                  _vm._m(20),
                  _c("div", { staticClass: "caseStudies__item--content" }, [
                    _vm._m(21),
                    _c("div", { staticClass: "caseStudies--cinemagraph" }, [
                      _c("div", { staticClass: "video__container" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://www.youtube.com/watch?v=AdMQFqmJp98"
                            },
                            on: {
                              click: function($event) {
                                _vm.ytModal($event)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "lazy",
                              attrs: {
                                "data-src":
                                  "https://i1.ytimg.com/vi/AdMQFqmJp98/maxresdefault.jpg"
                              }
                            }),
                            _c("div", { staticClass: "playbtn" })
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._m(22)
                ]
              )
            ]),
            _c(
              "section",
              {
                ref: "smbs",
                staticClass: "noBoxShadow",
                attrs: { id: "smbs" }
              },
              [
                _c(
                  "div",
                  {
                    ref: "collage",
                    staticClass: "caseStudies__item",
                    attrs: { id: "collage" }
                  },
                  [
                    _vm._m(23),
                    _c("div", { staticClass: "caseStudies__item--content" }, [
                      _vm._m(24),
                      _c("div", { staticClass: "caseStudies--cinemagraph" }, [
                        _c("div", { staticClass: "video__container" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "https://www.youtube.com/watch?v=aqyQRvno1jA"
                              },
                              on: {
                                click: function($event) {
                                  _vm.ytModal($event)
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "lazy",
                                attrs: {
                                  "data-src":
                                    "https://i1.ytimg.com/vi/aqyQRvno1jA/maxresdefault.jpg"
                                }
                              }),
                              _c("div", { staticClass: "playbtn" })
                            ]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              ]
            ),
            _c("section", { staticClass: "noBoxShadow" }, [
              _c(
                "div",
                {
                  ref: "queenlaundry",
                  staticClass: "caseStudies__item",
                  attrs: { id: "queenlaundry" }
                },
                [
                  _vm._m(25),
                  _c("div", { staticClass: "caseStudies__item--content" }, [
                    _vm._m(26),
                    _c("div", { staticClass: "caseStudies--cinemagraph" }, [
                      _c("div", { staticClass: "video__container" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://www.youtube.com/watch?v=ADIncQzGCSo"
                            },
                            on: {
                              click: function($event) {
                                _vm.ytModal($event)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "lazy",
                              attrs: {
                                "data-src":
                                  "https://i1.ytimg.com/vi/ADIncQzGCSo/maxresdefault.jpg"
                              }
                            }),
                            _c("div", { staticClass: "playbtn" })
                          ]
                        )
                      ])
                    ])
                  ])
                ]
              )
            ]),
            _c("section", { staticClass: "noBoxShadow" }, [
              _c(
                "div",
                {
                  ref: "plentea",
                  staticClass: "caseStudies__item",
                  attrs: { id: "plentea" }
                },
                [
                  _vm._m(27),
                  _c("div", { staticClass: "caseStudies__item--content" }, [
                    _vm._m(28),
                    _c("div", { staticClass: "caseStudies--cinemagraph" }, [
                      _c("div", { staticClass: "video__container" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://www.youtube.com/watch?v=m-N7O8Xe_As"
                            },
                            on: {
                              click: function($event) {
                                _vm.ytModal($event)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "lazy",
                              attrs: {
                                "data-src":
                                  "https://i1.ytimg.com/vi/m-N7O8Xe_As/maxresdefault.jpg"
                              }
                            }),
                            _c("div", { staticClass: "playbtn" })
                          ]
                        )
                      ])
                    ])
                  ])
                ]
              )
            ]),
            _c("section", { staticClass: "noBoxShadow" }, [
              _c(
                "div",
                {
                  ref: "fitfactory",
                  staticClass: "caseStudies__item",
                  attrs: { id: "fitfactory" }
                },
                [
                  _vm._m(29),
                  _c("div", { staticClass: "caseStudies__item--content" }, [
                    _vm._m(30),
                    _c("div", { staticClass: "caseStudies--cinemagraph" }, [
                      _c("div", { staticClass: "video__container" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://www.youtube.com/watch?v=9Kt4z9bqzB8"
                            },
                            on: {
                              click: function($event) {
                                _vm.ytModal($event)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "lazy",
                              attrs: {
                                "data-src":
                                  "https://i1.ytimg.com/vi/9Kt4z9bqzB8/maxresdefault.jpg"
                              }
                            }),
                            _c("div", { staticClass: "playbtn" })
                          ]
                        )
                      ])
                    ])
                  ])
                ]
              )
            ]),
            _c("section", { staticClass: "noBoxShadow" }, [
              _c(
                "div",
                {
                  ref: "blackwidow",
                  staticClass: "caseStudies__item",
                  attrs: { id: "blackwidow" }
                },
                [
                  _vm._m(31),
                  _c("div", { staticClass: "caseStudies__item--content" }, [
                    _vm._m(32),
                    _c("div", { staticClass: "caseStudies--cinemagraph" }, [
                      _c("div", { staticClass: "video__container" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://www.youtube.com/watch?v=XAR2HSxL1tw"
                            },
                            on: {
                              click: function($event) {
                                _vm.ytModal($event)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "lazy",
                              attrs: {
                                "data-src":
                                  "https://i1.ytimg.com/vi/XAR2HSxL1tw/maxresdefault.jpg"
                              }
                            }),
                            _c("div", { staticClass: "playbtn" })
                          ]
                        )
                      ])
                    ])
                  ])
                ]
              )
            ]),
            _c("section", { staticClass: "noBoxShadow" }, [
              _c(
                "div",
                {
                  ref: "buggigattolo",
                  staticClass: "caseStudies__item",
                  attrs: { id: "buggigattolo" }
                },
                [
                  _vm._m(33),
                  _c("div", { staticClass: "caseStudies__item--content" }, [
                    _vm._m(34),
                    _c("div", { staticClass: "caseStudies--cinemagraph" }, [
                      _c("div", { staticClass: "video__container" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://www.youtube.com/watch?v=6uDXHcWIyw4"
                            },
                            on: {
                              click: function($event) {
                                _vm.ytModal($event)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "lazy",
                              attrs: {
                                "data-src":
                                  "https://i1.ytimg.com/vi/6uDXHcWIyw4/maxresdefault.jpg"
                              }
                            }),
                            _c("div", { staticClass: "playbtn" })
                          ]
                        )
                      ])
                    ])
                  ])
                ]
              )
            ]),
            _c("section", { staticClass: "noBoxShadow no-divider" }, [
              _c(
                "div",
                {
                  ref: "anti",
                  staticClass: "caseStudies__item",
                  attrs: { id: "anti" }
                },
                [
                  _vm._m(35),
                  _c("div", { staticClass: "caseStudies__item--content" }, [
                    _vm._m(36),
                    _c("div", { staticClass: "caseStudies--cinemagraph" }, [
                      _c("div", { staticClass: "video__container" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://www.youtube.com/watch?v=cq255ePhDec"
                            },
                            on: {
                              click: function($event) {
                                _vm.ytModal($event)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "lazy",
                              attrs: {
                                "data-src":
                                  "https://i1.ytimg.com/vi/cq255ePhDec/maxresdefault.jpg"
                              }
                            }),
                            _c("div", { staticClass: "playbtn" })
                          ]
                        )
                      ])
                    ])
                  ])
                ]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "caseStudies__section" }, [
      _c("div", { staticClass: "caseStudies__section--intro" }, [
        _c("h1", [_vm._v("Cinemagraphs at Work")]),
        _c("p", [
          _vm._v(
            "Cinemagraphs help top brands and small businesses stand out, compete, and drive growth in digital marketing campaigns. We put cinemagraphs to the test in this case study series, and found that cinemagraphs outperform still images, leading to higher conversions, lower costs, and better results."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "caseStudies__item", attrs: { id: "pepsi" } },
      [
        _c("div", { staticClass: "caseStudies__item--logo" }, [
          _c("img", {
            staticClass: "lazy",
            attrs: {
              srcset:
                "https://cdn.flixel.com/static/static-web/casestudies/pepsico@2x.png" +
                " 2x, " +
                "https://cdn.flixel.com/static/static-web/casestudies/pepsico@1x.png" +
                " 1x"
            }
          })
        ]),
        _c("div", { staticClass: "caseStudies__item--content" }, [
          _c("div", { staticClass: "caseStudies--desc" }, [
            _c("p", [
              _vm._v(
                "PepsiCo is no stranger to generating brand awareness through visual storytelling. To launch their new lemon-lime beverage Mist Twst, they worked with Flixel Studios to test cinemagraph ads against still image ads on Facebook. The thumb-stopping engagement proved that cinemagraphs are the best way to put a twist on your campaign, and drive results."
              )
            ]),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "http://blog.flixel.com/pepsico-tests-cinemagraphs-in-facebook-ads/"
                }
              },
              [_vm._v("Learn more")]
            )
          ]),
          _c("div", { staticClass: "caseStudies--cinemagraph" }, [
            _c("div", { staticClass: "cinemagraph__container" }, [
              _c("iframe", {
                attrs: {
                  "data-src":
                    "https://media.flixel.com/cinemagraph/w7rgg2byigztup3yaer1?hd=true",
                  frameborder: "0",
                  allow: "autoplay"
                }
              })
            ])
          ])
        ]),
        _c("div", { staticClass: "caseStudies__item--metrics" }, [
          _c("div", { staticClass: "caseStudies__metric--item" }, [
            _c("h2", [_vm._v("75%")]),
            _c("h3", [_vm._v("Increase in CTR")])
          ]),
          _c("div", { staticClass: "caseStudies__metric--item" }, [
            _c("h2", [_vm._v("51x")]),
            _c("h3", [_vm._v("Increase in Engagement")])
          ]),
          _c("div", { staticClass: "caseStudies__metric--item" }, [
            _c("h2", [_vm._v("5.62")]),
            _c("h3", [_vm._v("Million Impressions")])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--logo" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          srcset:
            "https://cdn.flixel.com/static/static-web/casestudies/microsoft@2x.png" +
            " 2x, " +
            "https://cdn.flixel.com/static/static-web/casestudies/microsoft@1x.png" +
            " 1x"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--content" }, [
      _c("div", { staticClass: "caseStudies--desc" }, [
        _c("p", [
          _vm._v(
            "In a campaign promoting their new Surface product line, Microsoft tested cinemagraphs against still image ads on Facebook, Instagram, and Twitter. As Microsoft learned, holding attention and building a relationship with their audience is much more effective when living photos comes into play."
          )
        ]),
        _c(
          "a",
          {
            attrs: {
              href: "http://blog.flixel.com/flixel-microsoft-case-study/"
            }
          },
          [_vm._v("Learn more")]
        )
      ]),
      _c("div", { staticClass: "caseStudies--cinemagraph" }, [
        _c("div", { staticClass: "cinemagraph__container" }, [
          _c("iframe", {
            attrs: {
              "data-src":
                "https://media.flixel.com/cinemagraph/wdpcvu6zgptc417396m9?hd=true",
              frameborder: "0",
              allow: "autoplay"
            }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--metrics" }, [
      _c("div", { staticClass: "caseStudies__metric--item" }, [
        _c("h2", [_vm._v("110%")]),
        _c("h3", [_vm._v("Increase in Engagement on Twitter")])
      ]),
      _c("div", { staticClass: "caseStudies__metric--item" }, [
        _c("h2", [_vm._v("85%")]),
        _c("h3", [_vm._v("Increase in Engagement on Facebook")])
      ]),
      _c("div", { staticClass: "caseStudies__metric--item" }, [
        _c("h2", [_vm._v("45%")]),
        _c("h3", [_vm._v("Decrease in Cost Per Engagement")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--logo" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          srcset:
            "https://cdn.flixel.com/static/static-web/casestudies/mercedesbenz@2x.png" +
            " 2x, " +
            "https://cdn.flixel.com/static/static-web/casestudies/mercedesbenz@1x.png" +
            " 1x"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--content" }, [
      _c("div", { staticClass: "caseStudies--desc" }, [
        _c("p", [
          _vm._v(
            "Flixel Studios helped Mercedes-Benz enter the fast lane to growing their brand awareness with living photos. Take a look at how the cinemagraph ad shared a story that resonated, and drove results on Instagram."
          )
        ]),
        _c(
          "a",
          {
            attrs: {
              href:
                "http://blog.flixel.com/facebook-and-flixel-team-with-mercedes-on-first-ever-instagram-cinemagraph-ad/"
            }
          },
          [_vm._v("Learn more")]
        ),
        _c(
          "div",
          { staticClass: "caseStudies__item--metrics metrics--desktop" },
          [
            _c("div", { staticClass: "caseStudies__metric--item" }, [
              _c("h2", [_vm._v("6pt")]),
              _c("h3", [_vm._v("Lift in Brand Favourability")])
            ]),
            _c("div", { staticClass: "caseStudies__metric--item" }, [
              _c("h2", [_vm._v("34%")]),
              _c("h3", [_vm._v("Lift in Ad Recall")])
            ])
          ]
        )
      ]),
      _c(
        "div",
        {
          staticClass: "caseStudies--cinemagraph caseStudies--squareCinemagraph"
        },
        [
          _c("div", { staticClass: "cinemagraph__container" }, [
            _c("iframe", {
              attrs: {
                "data-src":
                  "https://media.flixel.com/cinemagraph/d5h7s6yxdinj8qqyox1r?hd=true",
                frameborder: "0",
                allow: "autoplay"
              }
            })
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "caseStudies__item--metrics metrics--mobile" },
      [
        _c("div", { staticClass: "caseStudies__metric--item" }, [
          _c("h2", [_vm._v("6pt")]),
          _c("h3", [_vm._v("Lift in Brand Favourability")])
        ]),
        _c("div", { staticClass: "caseStudies__metric--item" }, [
          _c("h2", [_vm._v("34%")]),
          _c("h3", [_vm._v("Lift in Ad Recall")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--logo" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          srcset:
            "https://cdn.flixel.com/static/static-web/casestudies/gobowling@2x.png" +
            " 2x, " +
            "https://cdn.flixel.com/static/static-web/casestudies/gobowling@1x.png" +
            " 1x"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies--desc" }, [
      _c("p", [
        _vm._v(
          "The Bowling Proprietors’ Association of America wanted to score big with a Facebook ads campaign. With the help of Flixel Studios, they created cinemagraph ads for their property GoBowling to drive real business results during the holiday season. Learn how they rolled one strike after another in this Facebook ads case study."
        )
      ]),
      _c(
        "a",
        {
          attrs: {
            href:
              "http://blog.flixel.com/case-study-gobowling-elevates-facebook-ads-cinemagraphs/"
          }
        },
        [_vm._v("Learn more")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--metrics" }, [
      _c("div", { staticClass: "caseStudies__metric--item" }, [
        _c("h2", [_vm._v("2.15")]),
        _c("h3", [_vm._v("Million Impressions")])
      ]),
      _c("div", { staticClass: "caseStudies__metric--item" }, [
        _c("h2", [_vm._v("6.7%")]),
        _c("h3", [_vm._v("CTR")])
      ]),
      _c("div", { staticClass: "caseStudies__metric--item" }, [
        _c("h2", [_vm._v("10")]),
        _c("h3", [_vm._v("Relevance Score")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--logo" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          srcset:
            "https://cdn.flixel.com/static/static-web/casestudies/travelalberta@2x.png" +
            " 2x, " +
            "https://cdn.flixel.com/static/static-web/casestudies/travelalberta@1x.png" +
            " 1x"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies--desc" }, [
      _c("p", [
        _vm._v(
          "Calgary-based agency Critical Mass worked with Flixel to produce an award-winning cinemagraph campaign for Travel Alberta. Take a look at how they captured the beautiful Alberta, Canada in a series of cinemagraph ads that inspired travel goals, and led to higher conversions."
        )
      ]),
      _c(
        "a",
        {
          attrs: {
            href:
              "http://blog.flixel.com/travel-alberta-uses-cinemagraphs-to-stop-time-and-capture-the-adventure-of-the-rockies/"
          }
        },
        [_vm._v("Learn more")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--metrics" }, [
      _c("div", { staticClass: "caseStudies__metric--item" }, [
        _c("h2", [_vm._v("2x")]),
        _c("h3", [_vm._v("Increase in Conversion Rate")])
      ]),
      _c("div", { staticClass: "caseStudies__metric--item" }, [
        _c("h2", [_vm._v("100%")]),
        _c("h3", [_vm._v("Increase in Traffic to Partner Sites")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--logo" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          srcset:
            "https://cdn.flixel.com/static/static-web/casestudies/theride@2x.png" +
            " 2x, " +
            "https://cdn.flixel.com/static/static-web/casestudies/theride@1x.png" +
            " 1x"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies--desc" }, [
      _c("p", [
        _vm._v(
          "Meet The Ride, Canada’s get-me-there app. Looking to scale their business while being mindful of their costs, The Ride ran a split A/B test ads campaign on Facebook comparing the effectiveness of cinemagraphs against still images, resulting in the cinemagraph ad driving increases in customer acquisition at lower costs."
        )
      ]),
      _c(
        "a",
        {
          attrs: {
            href:
              "http://blog.flixel.com/facebook-ads-case-study-cinemagraphs-results-small-business/"
          }
        },
        [_vm._v("Learn more")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--metrics" }, [
      _c("div", { staticClass: "caseStudies__metric--item" }, [
        _c("h2", [_vm._v("3.9x")]),
        _c("h3", [_vm._v("Increase in Conversion Rate")])
      ]),
      _c("div", { staticClass: "caseStudies__metric--item" }, [
        _c("h2", [_vm._v("65%")]),
        _c("h3", [_vm._v("Decrease in Cost Per Install")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--logo" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          srcset:
            "https://cdn.flixel.com/static/static-web/casestudies/giftagram@2x.png" +
            " 2x, " +
            "https://cdn.flixel.com/static/static-web/casestudies/giftagram@1x.png" +
            " 1x"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies--desc" }, [
      _c("p", [
        _vm._v(
          "Toronto startup Giftagram offers users a simple way to purchase unique gifts through their mobile app. They used cinemagraph ads on Facebook to develop their relationship with potential customers, accentuate their products and brand story, and lower costs."
        )
      ]),
      _c(
        "a",
        {
          attrs: {
            href:
              "http://blog.flixel.com/facebook-ads-case-study-cinemagraphs-giftagram/"
          }
        },
        [_vm._v("Learn more")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--metrics" }, [
      _c("div", { staticClass: "caseStudies__metric--item" }, [
        _c("h2", [_vm._v("16x")]),
        _c("h3", [_vm._v("Increase in Engagement")])
      ]),
      _c("div", { staticClass: "caseStudies__metric--item" }, [
        _c("h2", [_vm._v("61%")]),
        _c("h3", [_vm._v("Decrease in Cost Per Install")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--logo" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          srcset:
            "https://cdn.flixel.com/static/static-web/casestudies/inkbox@2x.png" +
            " 2x, " +
            "https://cdn.flixel.com/static/static-web/casestudies/inkbox@1x.png" +
            " 1x"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies--desc" }, [
      _c("p", [
        _vm._v(
          "Inkbox, the pioneer of the two week tattoo, used cinemagraphs created with Cinemagraph Pro to scale their reach on Facebook. In an A/B test comparing cinemagraph ads against still image ads, the cinemagraph ad increased engagement and brand awareness while lowering costs better than the still image ad."
        )
      ]),
      _c(
        "a",
        {
          attrs: {
            href:
              "http://blog.flixel.com/case-study-smb-inkbox-tests-cinemagraphs-vs-still-photo-ads-on-facebook/"
          }
        },
        [_vm._v("Learn more")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--metrics" }, [
      _c("div", { staticClass: "caseStudies__metric--item" }, [
        _c("h2", [_vm._v("117%")]),
        _c("h3", [_vm._v("Increase in CTR")])
      ]),
      _c("div", { staticClass: "caseStudies__metric--item" }, [
        _c("h2", [_vm._v("41%")]),
        _c("h3", [_vm._v("Decrease in CPC")])
      ]),
      _c("div", { staticClass: "caseStudies__metric--item" }, [
        _c("h2", [_vm._v("4pt")]),
        _c("h3", [_vm._v("Increase in Relevance Score")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--logo" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          srcset:
            "https://cdn.flixel.com/static/static-web/casestudies/collage@2x.png" +
            " 2x, " +
            "https://cdn.flixel.com/static/static-web/casestudies/collage@1x.png" +
            " 1x"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies--desc" }, [
      _c("p", [
        _vm._v(
          "Collage is a free HR and benefits platform built for businesses in Canada. They use cinemagraphs to share their office hero stories on Facebook."
        )
      ]),
      _c(
        "a",
        {
          attrs: {
            href:
              "http://blog.flixel.com/hr-software-small-business-shared-their-office-hero-stories-with-cinemagraphs/"
          }
        },
        [_vm._v("Learn more")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--logo" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          srcset:
            "https://cdn.flixel.com/static/static-web/casestudies/queenstreetlaundry@2x.png" +
            " 2x, " +
            "https://cdn.flixel.com/static/static-web/casestudies/queenstreetlaundry@1x.png" +
            " 1x"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies--desc" }, [
      _c("p", [
        _vm._v(
          "Take a look at how local Toronto laundromat Queen Street Laundry uses cinemagraphs to put a spin on their storytelling."
        )
      ]),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://blog.flixel.com/small-business-facebook-marketing-with-cinemagraphs/"
          }
        },
        [_vm._v("Learn more")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--logo" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          srcset:
            "https://cdn.flixel.com/static/static-web/casestudies/plentea@2x.png" +
            " 2x, " +
            "https://cdn.flixel.com/static/static-web/casestudies/plentea@1x.png" +
            " 1x"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies--desc" }, [
      _c("p", [
        _vm._v(
          "Driven by a passion for their product and community, Toronto tea bar Plentea explored cinemagraphs as a part of their Facebook and Instagram marketing."
        )
      ]),
      _c(
        "a",
        {
          attrs: {
            href:
              "http://blog.flixel.com/plentea-small-business-effective-facebook-video-ad/"
          }
        },
        [_vm._v("Learn more")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--logo" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          srcset:
            "https://cdn.flixel.com/static/static-web/casestudies/fitfactory@2x.png" +
            " 2x, " +
            "https://cdn.flixel.com/static/static-web/casestudies/fitfactory@1x.png" +
            " 1x"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies--desc" }, [
      _c("p", [
        _vm._v(
          "Watch how military-style Fit Factory Fitness gets their social media into shape by creating living photos with Cinemagraph Pro for iOS."
        )
      ]),
      _c(
        "a",
        {
          attrs: {
            href:
              "http://blog.flixel.com/fit-factory-fitness-create-video-facebook-ads-cinemagraphs/"
          }
        },
        [_vm._v("Learn more")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--logo" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          srcset:
            "https://cdn.flixel.com/static/static-web/casestudies/blackwidow@2x.png" +
            " 2x, " +
            "https://cdn.flixel.com/static/static-web/casestudies/blackwidow@1x.png" +
            " 1x"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies--desc" }, [
      _c("p", [
        _vm._v(
          "Check out how local tattoo parlour Black Widow takes their storytelling beyond the ink with cinemagraphs."
        )
      ]),
      _c(
        "a",
        {
          attrs: {
            href:
              "http://blog.flixel.com/black-widow-tattoo-small-businesses-create-better-facebook-ads/"
          }
        },
        [_vm._v("Learn more")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--logo" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          srcset:
            "https://cdn.flixel.com/static/static-web/casestudies/buggigattolo@2x.png" +
            " 2x, " +
            "https://cdn.flixel.com/static/static-web/casestudies/buggigattolo@1x.png" +
            " 1x"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies--desc" }, [
      _c("p", [
        _vm._v(
          "Explore how Italian restaurant Buggigatolo celebrates authentic food and community using cinemagraphs in Facebook ads."
        )
      ]),
      _c(
        "a",
        {
          attrs: {
            href:
              "http://blog.flixel.com/bugigattolo-restaurant-cinemagraphs-on-facebook-ads/"
          }
        },
        [_vm._v("Learn more")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies__item--logo" }, [
      _c("img", {
        staticClass: "lazy",
        attrs: {
          srcset:
            "https://cdn.flixel.com/static/static-web/casestudies/anti@2x.png" +
            " 2x, " +
            "https://cdn.flixel.com/static/static-web/casestudies/anti@1x.png" +
            " 1x"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caseStudies--desc" }, [
      _c("p", [
        _vm._v(
          "Take a look at how streetwear line ANTI makes a statement by using cinemagraphs. "
        )
      ]),
      _c(
        "a",
        {
          attrs: {
            href: "http://blog.flixel.com/small-business-facebook-ads-anti/"
          }
        },
        [_vm._v("Learn more")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45778b0d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45778b0d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/CaseStudies.vue
// module id = null
// module chunks = 